import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHeroBanner } from '../services/requests';
import type { CreateContentRequest } from '../schemas/auth';
import useNotification from '../components/Notification';

interface UseContentCreateOptions {
  onSuccess?: () => void;
  successMessage?: string;
  successDescription?: string;
}

export const useContentCreate = (options?: UseContentCreateOptions) => {
  const { showNotification } = useNotification();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateContentRequest) => createHeroBanner(payload),
    onSuccess: () => {
      showNotification({
        type: 'success',
        message: options?.successMessage || 'Content Created',
        description: options?.successDescription || 'The content has been created successfully.',
      });

      queryClient.invalidateQueries({
        queryKey: ['listContents'],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ['infiniteContents'],
        exact: false,
      });

      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
};
